import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { UiService } from '../shared/services/ui.service';
import { CitizenService } from '../shared/services/citizen.service';
import { Citizen } from '../shared/models/classes/citizen/citizen';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../shared/services/language.service';

@Component({
    selector: 'app-citizen',
    templateUrl: './citizen.component.html',
    styleUrls: ['./citizen.component.scss']
})
export class CitizenComponent implements OnInit, OnDestroy {
    private subscription = new Subscription();

    selectedArticleType = 'expense';
    ordinarySrv = "ordinary";
    extraordinarySrv = "extraordinary";

    citizenData: Citizen;
    codeFromUrl: string;

    constructor(
        private uiSrv: UiService,
        private citizenSrv: CitizenService,
        private languageSrv: LanguageService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getRouteData();
        this.initSubscriptions();
    }

    private getRouteData(): void {
        var code = this.route.snapshot.paramMap.get('code');
        if (code && code.length === 5)
            code = 'commune.' + code;
        this.codeFromUrl = code;
    }

    private initSubscriptions(): void {
        this.subscription.add(
            this.citizenSrv.citizenChanged
            .subscribe(citizen => {
                this.citizenData = citizen;
                if(citizen) {
                    this.uiSrv.changeTitle(citizen.organism.text.fullLabel, false);
                } else {
                    this.uiSrv.changeTitle("main.nav.links.citizen.shortLabel");
                }
            })
        );

        this.subscription.add(
            this.languageSrv.languageChanged
            .subscribe(() => {
                if(this.codeFromUrl != null) {
                    this.citizenSrv.get(this.codeFromUrl).subscribe();
                } else {
                    this.citizenSrv.citizenChanged.next(null);
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
